// extracted by mini-css-extract-plugin
export default {"card":"nvAYa2kpJPRIrgsaEWaQ","table":"_nGmZdC6jzqPgEt6YDKr","link-container":"dZgeuuMKhRUztKyRT_GQ"};